import React from 'react';
import { Box, Container } from '@mui/material';
import LanguageSelector from './LanguageSelector';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/img/logo.svg';

const Header = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
                <Logo onClick={() => navigate('/')} style={{ cursor: 'pointer', width: 150 }} />
                <LanguageSelector />
            </Box>
        </Container>
    );
};

export default Header;
